import * as React from "react";

import { Spin, Layout } from "antd";

import "./Loading.css";
import { topNavHeightPx } from "../../../View/Products/Constants/StyleConstants";

interface ILoadingProps {
    title?: string;
    style?: React.CSSProperties;
}

export const Loading: React.FunctionComponent<ILoadingProps> = (props) => {
    return (
        <div style={props.style}>
            <div style={{ display: "flex", flexDirection: "column" }}>
                {props.title && (
                    <div style={{ marginBottom: "16px", textAlign: "center" }}>
                        {props.title}
                    </div>
                )}
                <Spin />
            </div>
        </div>
    );
};

interface IComponentLoadingProps {
    title: string;
}

export const ComponentLoading: React.FunctionComponent<IComponentLoadingProps>
    = (props: IComponentLoadingProps) => {
        return (
            <Layout
                style={{
                    height: `calc(100% - ${topNavHeightPx}px)`
                }}
            >
                <Layout.Content className="loading-component-layout-content">
                    <div className="loading-component-container">
                        <Loading title={props.title} style={{ marginTop: "80px" }} />
                    </div>
                </Layout.Content>
            </Layout>
        );
    };
